var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardvaloresresiliencia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M117,302.09c-73.44,42.4-73.43,111.14,0,153.53s192.49,42.4,265.92,0,73.43-111.13,0-153.53S190.47,259.7,117,302.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M139.06,374.61a30.74,30.74,0,0,0,5.37,5.85,62.11,62.11,0,0,0,24.47,12.91c8.87,2.37,17.94,1.71,25.92,6.93,5.13,3.36,9.75,7.42,14.8,10.9,8.72,6,17.8,11.57,27.92,14.87,5.56,1.81,9.44,1.9,15.25,1.71,3.75-.12,7.51-.35,11.21.38,8.26,1.65,14.85,7.28,21.34,12.26,6.94,5.34,13.62,9.18,22.19,11.24,6.64,1.6,30.71,3.25,28.54-9.08-.54-3.06-3.16-5.25-5.61-7.17-6.16-3.08-12-9.38-17.45-13.63-5.22-4.08-8.13-9.18-12-14.56-3.18-4.41-6.4-8.86-10.46-12.49-8.41-7.35-19.94-12.28-29.63-17.93q-16.41-9.57-33-18.88c-12.4-7-25.65-14.06-39.88-13.63A49.56,49.56,0,0,0,174.77,347c-4.7,1.48-9.18,3.33-14.09,4.13-5.3.87-10.89.83-15.82,3.22s-8.7,7.49-8.45,12.94A14.45,14.45,0,0,0,139.06,374.61Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Prism--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.83,97.63a4.06,4.06,0,0,1,3.62-1.85l20.42,3.1a4,4,0,0,1,2.89,2.83l17.76,45.36a12.62,12.62,0,0,1-1.72,11.3L356.09,220.6c-1.14,1.43-2.44,2-3.62,1.85l-20.4-3.09c-1.18-.18-2.24-1.14-2.91-2.84L311.4,171.17a12.65,12.65,0,0,1,1.72-11.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,96.75h0l.26,0,2,.3c4.77.72,17.46,2.64,18.43,2.8s1.61.92,2.12,2.21l17.76,45.35A11.71,11.71,0,0,1,405,157.74L355.31,220a3.38,3.38,0,0,1-2.43,1.5l-.26,0L335,218.8l-2.81-.43c-.87-.13-1.62-.92-2.13-2.21l-17.76-45.35a11.76,11.76,0,0,1,1.57-10.32l49.72-62.24a3.38,3.38,0,0,1,2.42-1.5m0-1a4.3,4.3,0,0,0-3.21,1.88l-49.71,62.24a12.65,12.65,0,0,0-1.72,11.3l17.76,45.35c.67,1.7,1.73,2.66,2.91,2.84l20.4,3.09a2.83,2.83,0,0,0,.41,0,4.25,4.25,0,0,0,3.21-1.88l49.71-62.23a12.62,12.62,0,0,0,1.72-11.3l-17.76-45.36a4,4,0,0,0-2.89-2.83l-20.42-3.1a2.73,2.73,0,0,0-.41,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,155.28,335.7,217.51a4.15,4.15,0,0,1-3.47,1.88c2.13.32,19.09,2.88,20.23,3.07a4.09,4.09,0,0,0,3.63-1.86l49.71-62.23a11.63,11.63,0,0,0,2.18-5.3c-7.31-1.11-14.33-2.19-20.39-3.09A11.63,11.63,0,0,1,385.41,155.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.12,144,369.36,98.62c-.67-1.7-1.73-2.66-2.91-2.84a4.06,4.06,0,0,0-3.62,1.85l-49.71,62.24a12.65,12.65,0,0,0-1.72,11.3l17.76,45.35c.67,1.7,1.73,2.66,2.91,2.84s2.48-.42,3.62-1.85l49.71-62.24A12.64,12.64,0,0,0,387.12,144Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.61,198.84l.64-12.22c6.54-12.68.28-26-4.68-28.83,14.42-15.3,10.42-37,6.24-47.61l-39.69,49.69a12.65,12.65,0,0,0-1.72,11.3l17.76,45.35c.67,1.7,1.73,2.66,2.91,2.84l20.4,3.09c1.18.18,2.48-.42,3.62-1.85l14.45-18.09Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--prism--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.36,153.64c-1.9-.72-3.49-.56-4.52.28S86,167.63,85,168.49s-1.49,2.36-1.17,4.36l8.69,53.66a14.09,14.09,0,0,0,8.06,9.88L183.67,268c1.9.72,3.49.56,4.52-.28L206,253.13c1-.85,1.51-2.37,1.18-4.38l-8.69-53.66a14.09,14.09,0,0,0-8.06-9.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1,154.18a5.47,5.47,0,0,1,1.91.39l83.11,31.57a13.25,13.25,0,0,1,7.43,9.11l8.69,53.66c.25,1.58,0,2.8-.83,3.44l-17.85,14.56a2.5,2.5,0,0,1-1.63.51A5.37,5.37,0,0,1,184,267l-83.11-31.57a13.22,13.22,0,0,1-7.43-9.11L84.8,172.69c-.26-1.57,0-2.79.82-3.43s11.93-9.74,16.1-13.14l1.75-1.43a2.52,2.52,0,0,1,1.63-.51m0-1a3.51,3.51,0,0,0-2.26.74c-1,.84-16.83,13.71-17.86,14.57s-1.49,2.36-1.17,4.36l8.69,53.66a14.09,14.09,0,0,0,8.06,9.88L183.67,268a6.45,6.45,0,0,0,2.26.46,3.49,3.49,0,0,0,2.26-.74L206,253.13c1-.85,1.51-2.37,1.18-4.38l-8.69-53.66a14.09,14.09,0,0,0-8.06-9.88l-83.11-31.57a6.37,6.37,0,0,0-2.26-.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,221.84l83.09,31.57c1.82.69,3.35.59,4.4-.17-1.86,1.53-16.7,13.62-17.7,14.45s-2.63,1-4.54.27l-83.09-31.57a13,13,0,0,1-5.11-3.85c6.4-5.22,12.53-10.24,17.85-14.55A12.8,12.8,0,0,0,118.41,221.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.35,212l-8.69-53.66c-.33-2,.15-3.53,1.18-4.37s2.62-1,4.52-.28l83.11,31.57a14.09,14.09,0,0,1,8.06,9.88l8.69,53.66c.33,2-.15,3.53-1.18,4.38s-2.62,1-4.52.28l-83.11-31.57A14.11,14.11,0,0,1,110.35,212Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,195.09a14.09,14.09,0,0,0-8.06-9.88l-52.88-20.09.93,18.68,4.33,2.5a49.92,49.92,0,0,0-11.09,40.9l-17.24,14.49L183.67,268c1.9.72,3.49.56,4.52-.28L206,253.13c1-.85,1.51-2.37,1.18-4.38Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.79,218.72a73.91,73.91,0,1,1,73.91-73.91A74,74,0,0,1,265.79,218.72Zm0-146.67a72.76,72.76,0,1,0,72.77,72.76A72.84,72.84,0,0,0,265.79,72.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88,223.35a74.27,74.27,0,1,1,74.27-74.27A74.35,74.35,0,0,1,237.88,223.35Zm0-147.39A73.12,73.12,0,1,0,311,149.08,73.19,73.19,0,0,0,237.88,76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36,225.18a74.27,74.27,0,1,1,74.27-74.27A74.35,74.35,0,0,1,206.36,225.18Zm0-147.39a73.12,73.12,0,1,0,73.12,73.12A73.2,73.2,0,0,0,206.36,77.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.53,195.5a74.27,74.27,0,1,1,74.27-74.27A74.34,74.34,0,0,1,259.53,195.5Zm0-147.38a73.12,73.12,0,1,0,73.12,73.11A73.2,73.2,0,0,0,259.53,48.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,200.26A74.27,74.27,0,1,1,321.94,126,74.35,74.35,0,0,1,247.67,200.26Zm0-147.38A73.12,73.12,0,1,0,320.79,126,73.2,73.2,0,0,0,247.67,52.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,194.57a43.66,43.66,0,1,1,43.66-43.66A43.71,43.71,0,0,1,247.67,194.57Zm0-86.17a42.51,42.51,0,1,0,42.51,42.51A42.56,42.56,0,0,0,247.67,108.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,163a39.47,39.47,0,1,1,39.47-39.47A39.51,39.51,0,0,1,222.6,163Zm0-77.79a38.32,38.32,0,1,0,38.33,38.32A38.36,38.36,0,0,0,222.6,85.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,168.6a39.48,39.48,0,1,1,39.48-39.48A39.52,39.52,0,0,1,233.07,168.6Zm0-77.8a38.33,38.33,0,1,0,38.33,38.32A38.36,38.36,0,0,0,233.07,90.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,147.56a39.47,39.47,0,1,1,39.47-39.47A39.52,39.52,0,0,1,209.09,147.56Zm0-77.8a38.33,38.33,0,1,0,38.33,38.33A38.37,38.37,0,0,0,209.09,69.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8,148.26a37.39,37.39,0,1,1,37.38-37.38A37.43,37.43,0,0,1,224.8,148.26Zm0-73.62A36.24,36.24,0,1,0,261,110.88,36.28,36.28,0,0,0,224.8,74.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.59,153.58a43.66,43.66,0,1,1,43.67-43.66A43.71,43.71,0,0,1,263.59,153.58Zm0-86.17a42.51,42.51,0,1,0,42.52,42.51A42.56,42.56,0,0,0,263.59,67.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,185.15a74.27,74.27,0,1,1,74.27-74.27A74.35,74.35,0,0,1,233.07,185.15Zm0-147.39a73.12,73.12,0,1,0,73.13,73.12A73.2,73.2,0,0,0,233.07,37.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36,195.5h0a74.27,74.27,0,1,1,74.27-74.27,73.72,73.72,0,0,1-74.27,74.27Zm0-147.38a73.12,73.12,0,0,0,0,146.23h0a73.12,73.12,0,1,0,0-146.23Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cylinder--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.63,154.14c4.41-.61,8.43-4.13,11-10.42,5.13-12.59,2.53-31.49-5.81-42.23-4.16-5.37-9-7.67-13.39-7.07L234.29,107.5c-4.41.61-8.42,4.13-11,10.42-5.13,12.59-2.53,31.49,5.81,42.23,4.17,5.37,9,7.67,13.39,7.07Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05,129.61l-44.18,24.62-1-34.35-17-9a20.73,20.73,0,0,0-4.53,7.07c-5.13,12.59-2.53,31.49,5.81,42.23,4.17,5.37,9,7.67,13.39,7.07l89.66-12.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,110.08c7.31-1.89,51.54-9.64,77.55-13.21L234.29,107.5c-4.41.61-8.42,4.13-11,10.42-3.31,8.14-3.38,18.91-.78,28.41C219.76,129.82,226.81,112,234.1,110.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.81,101.49c-4.16-5.37-9-7.67-13.39-7.07s-8.42,4.13-11,10.42c-5.13,12.59-2.53,31.5,5.8,42.23,4.17,5.37,9,7.68,13.39,7.07s8.43-4.13,11-10.42C353.75,131.13,351.15,112.23,342.81,101.49Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.81,101.49c-4.16-5.37-9-7.67-13.39-7.07s-8.42,4.13-11,10.42c-5.13,12.59-2.53,31.5,5.8,42.23,4.17,5.37,9,7.68,13.39,7.07s8.43-4.13,11-10.42C353.75,131.13,351.15,112.23,342.81,101.49Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cube--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "142.85 124.42 144.76 180.36 192.25 150.74 190.34 94.8 142.85 124.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.34 94.8 188.7 149.29 144.76 180.36 192.25 150.74 190.34 94.8",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.34 94.8 239.74 121.12 241.65 177.06 192.25 150.74 190.34 94.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.76 180.36 194.16 206.68 241.65 177.06 192.25 150.74 144.76 180.36",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--prism--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "181.75 199.43 235.9 230.69 344.2 168.17 290.05 136.9 181.75 199.43",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.75 199.43 235.9 230.69 344.2 168.17 290.05 136.9 181.75 199.43",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "234.4 169.03 332.05 175.19 344.2 168.16 336.37 163.64 252.85 158.38 234.4 169.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.25 191.63 185.06 197.52 282.71 203.67 292.9 197.78 195.25 191.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.63 150.43 260.99 153.68 326.23 157.79 319.21 153.74 266.63 150.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.98 217.37 277.44 206.71 184.19 200.84 207.17 214.1 258.98 217.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.38 176.55 215.74 179.8 313.39 185.95 319.03 182.7 221.38 176.55",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "181.75 199.43 235.9 230.69 235.9 267.67 181.75 236.41 181.75 199.43",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.75 199.43 235.9 230.69 235.9 267.67 181.75 236.41 181.75 199.43",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.2 168.17 344.2 205.15 235.9 267.67 235.9 230.69 344.2 168.17",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.2 168.17 344.2 205.15 235.9 267.67 235.9 230.69 344.2 168.17",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sphere--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.72,172.4a47,47,0,0,0-14.31.76,66.81,66.81,0,0,0-11,3.74,47.66,47.66,0,1,0,25.34-4.5Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.69,251.81c9.17-5.11,5.05-15.74-9.77-19.77s-30.82-.42-26,13.6c-20.1-10.62-25.3-48.42-6.55-65.87a47.61,47.61,0,1,0,72.17,50.47C226.07,237.84,216.15,251.13,198.69,251.81Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,218.82c-1.32,3.36-4.58,6.14-8.16,6-5.42-.14-8.59-5.84-11.57-10.36-7.68-11.59-20.56-18.91-33.92-22.82a15.36,15.36,0,0,1-4.77-2,4.6,4.6,0,0,1-2-4.46,7.73,7.73,0,0,1,3.07-4.24,28.44,28.44,0,0,1,11.21-3.41c10-.89,20.47,2.12,28.93,7.41s15,13.38,17.4,23.16C223.08,211.66,223.38,215.46,222.07,218.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.93,212.82a12.11,12.11,0,0,0,3.12,5.12,7,7,0,0,0,3.14,1.87c12.35,3,5.61-26.42-3.68-19.41a8.55,8.55,0,0,0-2.89,5A14.26,14.26,0,0,0,206.93,212.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vase--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.41,165.36c-47,82.37-145.16,123.73-237.33,104-30.11-6.48-58.79-19.25-83-37.64a2.73,2.73,0,0,1,3-4.57,258.65,258.65,0,0,0,82.56,28.53c6.83,1,14.67,2,21.58,2.42a251.72,251.72,0,0,0,32.5.06c5.19-.29,11-1.07,16.16-1.55,2.67-.44,8-1.29,10.69-1.72,3.5-.48,12.28-2.6,15.87-3.34,3.49-.94,6.94-2,10.42-2.95,5.05-1.32,10.42-3.49,15.4-5.14,4.83-1.95,10.29-4.06,15-6.25l9.79-4.7c6.38-3.43,12.78-6.86,18.85-10.83,2.59-1.58,6.67-4.17,9.1-6s6.57-4.5,8.87-6.38l8.6-6.78c2.77-2.37,5.46-4.85,8.23-7.25A292.52,292.52,0,0,0,401.93,163a2.1,2.1,0,0,1,3.48,2.33Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.89,414.4s-9.75-6.6-2.33-16.29c1.05-1.37,26.48-27.56,26.48-27.56l-27.31-15.77L288.11,391l-1.34,2.23s-8.14,18.33,4.06,20.78C297.08,415.25,312.89,414.4,312.89,414.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.61,409.83a5.6,5.6,0,0,0,.26,3.31c.5,1.42,7.41,6.84,9.19,9.15s2,3.25,4,6.42c2.24,3.51,3.46,7.84,13.35,11.3s16.68,2.31,21.14.4a11.06,11.06,0,0,0,4-3.33s1.61-5.65-1.51-6.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,400.6a12.55,12.55,0,0,1,3.75,1,1.88,1.88,0,0,1,1.34,1.52c.05.81-.25,1.6-.13,2.41a6.23,6.23,0,0,0,1,2.39,66.26,66.26,0,0,0,12.82,14.43c3.23,2.85,6.43,6,6.62,10.57.12,2.91-3.61,6.77-16.27,7.08-6.46.16-16.24-4.26-19.13-8.33s-4.11-7.62-6.45-10.6-9.46-7.76-10.78-11.24a18.72,18.72,0,0,1,1.53-7.81c.89-2.59,4.25-6.45,4.91-8.1a4.67,4.67,0,0,1,4.06-2.94l-1.32,2.33c-3.3,6.76,3.63,14.58,4.13,14.4.68-.23.67-2.58.84-3.18.51-1.74,1.58-2.43,3.21-3.06a22.21,22.21,0,0,1,7.7-1A16.91,16.91,0,0,1,304.8,400.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.06,440c-6.46.16-16.24-4.26-19.13-8.33a41.91,41.91,0,0,1-2.61-4.21c.22.25.43.52.62.72.44.44.88.87,1.34,1.29a14.37,14.37,0,0,0,6.25,3.65c2.12.45,7.33,1.74,9-.34,1-1.18.52-3.08-.49-4.55-.42-.62-1.73-2.09-1.73-2.09a23.68,23.68,0,0,1,6.4-3.88c4.35-1.58,4.72-1.13,4.72-1.13a10.48,10.48,0,0,0,2.65,2.12,7.8,7.8,0,0,0,3.16.93,4.72,4.72,0,0,0,1.18-.17c2.84,2.3,5,4.55,4.91,8.91C330.11,435.82,326.71,439.68,314.06,440Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,416.75a8.09,8.09,0,0,1,1.92,3.48,7.79,7.79,0,0,0,.2,1.61c.67,1.59,2.71.59,3.08-.71a3.61,3.61,0,0,0,.11-1.35,60.06,60.06,0,0,1-10-11.86,9.83,9.83,0,0,1-.78-1.47l0-.05a15,15,0,0,0,.93,3.45A36.37,36.37,0,0,0,315.51,416.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.82,403.23a11.55,11.55,0,0,1-1.33-6.22,22,22,0,0,1,.76-3.75c.87-1.86,2.38-2.15,3.86-2.28l-1.32,2.33c-.7,1.45-.63,5.31.14,7.45a18.11,18.11,0,0,0,3.7,6.5c4.56,5.39,5.53,7.94,10.29,12.42s9.05,6,8.8,7-2,2-6.33-.82-10-9.88-12.41-13.65S286.8,407.27,284.82,403.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,426.2a.6.6,0,0,0,.36-.12c3.76-2.74,6.24-3.77,11.48-3.59a.65.65,0,0,0,.05-1.3c-5.54-.18-8.3.92-12.3,3.84a.66.66,0,0,0-.14.91A.65.65,0,0,0,307,426.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,422.42a.66.66,0,0,0,.38-.12c4.11-2.69,7.09-3.52,12.71-3.28a.66.66,0,1,0,.08-1.32c-5.93-.34-9.2.64-13.56,3.5a.66.66,0,0,0-.19.93A.72.72,0,0,0,303.6,422.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.18,418.63a.85.85,0,0,0,.4-.1c4.45-2.65,7.92-3.38,13.93-3a.72.72,0,0,0,.79-.62.7.7,0,0,0-.67-.74c-6.33-.49-10.12.36-14.84,3.17a.66.66,0,0,0-.22.95A.74.74,0,0,0,300.18,418.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,414.85a.9.9,0,0,0,.42-.1c4.8-2.6,8.77-3.23,15.16-2.66a.75.75,0,0,0,.85-.62.73.73,0,0,0-.7-.77c-6.71-.63-11,.08-16.11,2.85a.66.66,0,0,0-.26,1A.81.81,0,0,0,296.75,414.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.32,411.06a.89.89,0,0,0,.45-.09c5.14-2.55,9.61-3.09,16.39-2.34a.8.8,0,0,0,.9-.62.77.77,0,0,0-.72-.81c-7.11-.78-11.94-.19-17.39,2.52a.67.67,0,0,0-.3,1A.84.84,0,0,0,293.32,411.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.12,381.09c1.84,3.7,12.64,13.33,25.18,12.72,0,0,21-21.09,32.58-33.27,11.19-11.79,14.05-19.36,13.23-25.28s-4-12.58-17.46-22.51C329.76,301,306.8,287.26,306.8,287.26h-47s-6.29,17.57,1.05,29.61,15.61,14.44,29.18,19.82c15.37,6.1,23.3,9.28,23.3,9.28s-2.34,2.31-8,12.12C300.85,365.77,292.12,381.09,292.12,381.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,313.58c-.58,9.06-7,18.57-14.87,21.64L313.35,346l-30.29-12V310.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.35,346l11.06,4.16-14.64.7A39.3,39.3,0,0,1,313.35,346Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,323c-3.12-1.44-6-.61-9.08,1.57s-5.28,6.36-4.21,12.05,2.21,8.71.33,13.68-4.75,12.82-1.1,20.23,9.81,9.39,13.63,10.39,9-.38,10.91-2.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.46,328.9c-2.35-2.62-7.15-4.52-10.47-5.43s-8.23-.87-11.6,2.79c-4,4.35-4.07,8.86-3.06,14.29s.1,9-1.91,14.86-1.51,15.47,6.13,20.6,13.86,4.22,17.17,2.41,3.78-4.21,3.05-6.93-3.05-6.13-3.55-10.05c-.21-1.64-.46-4.19.14-5.78s2.74-2.4,3.14-4.27a1.24,1.24,0,0,0,0-.47c-.11-.54-.73-.78-1.23-1-1.63-.71-.48-4.06-.3-5.47.28-2.17.55-4.34.83-6.52C183.13,335.43,184.14,331.41,184.46,328.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.83,366.73a3.53,3.53,0,0,1-1.75-1.19A8.69,8.69,0,0,1,178.7,362a63.26,63.26,0,0,0-8.7.7c-.19,1.18.14,1.81.24,3.5a2.66,2.66,0,0,1-1.73,2.58,5.07,5.07,0,0,1-3,.33,9.91,9.91,0,0,1-6.85-5,15.25,15.25,0,0,1-1.8-6.74c-1.31,5.85-.22,14.1,6.65,18.71,7.63,5.12,13.86,4.22,17.17,2.41s3.78-4.21,3.05-6.93A39.26,39.26,0,0,0,181.83,366.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.85,347.61a22.47,22.47,0,0,0-1.55,9.69c.27,4.53,1.58,6.49-.16,7.17s-2.06-1.07-2.33-6.15A24.33,24.33,0,0,1,170,346.69a30.81,30.81,0,0,0,2-9.06,12.62,12.62,0,0,1,5.42-9.19,6.05,6.05,0,0,1,6.32-.29s2.62,1.25,1,3c-.85-1.48-3.34-2.72-6.61-.55a10.76,10.76,0,0,0-4.51,8.66C173.64,341.88,173,344.17,171.85,347.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.67,363.54a.69.69,0,0,1-.18-1.36c3.27-.89,10.8-1.31,11.82.3a.69.69,0,1,1-1.16.74c-.64-.54-6.44-.76-10.29.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,359.4a.7.7,0,0,1-.59-.32c-.63-.54-6.43-.78-10.29.26a.69.69,0,0,1-.85-.49.68.68,0,0,1,.49-.84c3.27-.88,10.8-1.28,11.82.33a.68.68,0,0,1-.21,1A.66.66,0,0,1,180.33,359.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,355.71a.7.7,0,0,1-.63-.4c-.56-.62-6.29-1.58-10.24-1a.68.68,0,0,1-.78-.59.7.7,0,0,1,.59-.78c3.35-.46,10.87.09,11.68,1.82a.68.68,0,0,1-.33.92A.59.59,0,0,1,181,355.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.24,346.39c-1.08,1.87-1,3.91.66,2.8s5.21.42,9.65,2.19,15.6,6.94,15.6,6.94l13.69-23c-11.71-3.14-14.44-2.25-27.47-5.77-5.84-1.58-9.62,3.23-10.38,7.79S173.2,344.72,172.24,346.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.44,287.26c-4.95,8.31-6,14.85-7,23.31-1.11,9.41-3.69,28.09-3.69,28.09-8.41-3.09-19.86-6.12-39.58-9,0,0-11,6.2-8.89,25.32,0,0,30.3,18.1,47.36,25.84,17.57,8,26.84,5.68,34.49-5.52,7.07-10.36,20.73-41.69,20.73-41.69,12.51-.79,34.37-24.06,30.18-46.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,338.66c-1.55,10.9-1.16,18.31,0,24.81-6.61-7.59-3.8-26.13-3.8-26.13C232.37,337.79,233.66,338.24,234.79,338.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shoulder--inject-2",
    d: "M324.53,211.26c18.22-2.54,24.13,7.62,25.35,12.22s1.05,10.23-7.83,23.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-2",
    d: "M240.28,299.61a202.26,202.26,0,0,1,13.81-44.68c7.13-16.48,19.8-33.07,25.88-38.17,0,0,10.44-1.49,26.17-4.28s26.53-1.14,32.3,3.16,9.37,10.68,7.73,19.75-10,21.66-14.76,29.12-6.63,12.36-7.24,18.74c-.46,4.79.46,7.55-1.09,13.35C306.17,319.12,258.15,314.82,240.28,299.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-2",
    d: "M320.37,211.1v1c7.61,0,13.65,1.5,17.46,4.33,6.27,4.67,8.73,11,7.33,18.75-1.49,8.24-8.78,19.62-13.6,27.14l-1,1.61c-4.83,7.57-6.76,12.59-7.4,19.19a41.18,41.18,0,0,0-.14,4.72,28,28,0,0,1-.87,8.27c-7.31,9.59-21.6,15.09-39.26,15.09-16.33,0-32.52-4.71-41.47-12A201.31,201.31,0,0,1,255,255.34c7-16.28,19.35-32.41,25.37-37.6,1.82-.27,11.8-1.74,25.91-4.24a80.74,80.74,0,0,1,14.05-1.37v-1m0,0a82.25,82.25,0,0,0-14.23,1.38c-15.73,2.79-26.17,4.28-26.17,4.28-6.08,5.1-18.75,21.69-25.88,38.17a202.26,202.26,0,0,0-13.81,44.68c9.09,7.74,26,12.65,42.59,12.65,16.07,0,31.9-4.59,40.21-15.66,1.55-5.8.63-8.56,1.09-13.35.61-6.38,2.48-11.28,7.24-18.74s13.12-20,14.76-29.12-1.95-15.46-7.73-19.75c-3.83-2.85-9.86-4.54-18.07-4.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.36,220.29H300c3.12,7.82,9.3,19.06,20.8,26.3l.79-3.43C317.55,240.3,310.72,234.61,304.36,220.29Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.14,220.29c1,11.4-1.66,20.9-2.87,22.5l1.23,3.9c2.37-3.44,5.17-14.18,3.86-26.4Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.94,250s5.16,40.84,5.33,44.84-6.26,13.64-7.12,14.11-6.35-9.06-6.37-12.23,4.79-46.82,4.79-46.82Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.27,242.79a8.82,8.82,0,0,0-4.73.37c-.91,1.57-1.26,4-.59,5.2s2,3,3.56,2.93,3-2.06,3.22-4C328,245.18,326.27,242.79,326.27,242.79Z",
    style: {
      fill: "#8700A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.27,242.79a8.82,8.82,0,0,0-4.73.37c-.91,1.57-1.26,4-.59,5.2s2,3,3.56,2.93,3-2.06,3.22-4C328,245.18,326.27,242.79,326.27,242.79Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.43,165c-7.1,6.85-5.68,15.66-4,24.53,2,10.11,1.86,13.33,7.34,16.26,1.2-31.17,8.09,7.69,34.92-14.48,4.85-4,6.21-17.49,1.24-24.05C338.88,158,320.27,152.13,306.43,165Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.33,199.35c4.38,2.25,6.69-.71,6.69-.71l-4.93,11.23s-3.1,6.95,2.44,10.91c15.37,11,11.38,14.77,16.47,19.92,2-2.17,2.62-12.57,3.13-15.29l4.43-10.83a34.49,34.49,0,0,0,5.53.19c4.37-.26,7.07-3.14,8.79-7.68,2.78-7.29,3.35-18.58,1.84-33.39-4.47-4.2-20.23-6.27-31-.81-.32,8.61-2.76,9.81-3.05,13.51-.33,4.15-.69,5.07-2,5.53s-2.29-1.57-2.71-2.84c-.7-2.12-1.34-3.5-3.32-4.17s-4.27-.51-6.34,2.07C295.12,191,299.14,197.72,302.33,199.35Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.56,214.58c-5.1-.66-12.06-3.92-14.74-6.86s-4.15-8.36-4.15-8.36a16.59,16.59,0,0,0,2.92,10.1c3.41,4.9,14.62,8.4,14.62,8.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.09,177.39c-.14,0-.3.09-.3.22s.13.19.24.24a4.52,4.52,0,0,1,.51.34,1.44,1.44,0,0,1,.41.44,1.21,1.21,0,0,1,.12.41,4.5,4.5,0,0,1,.07.72c0,.2.17.33.36.17a.55.55,0,0,0,.15-.24,1.75,1.75,0,0,0,.13-.84,1.65,1.65,0,0,0-.13-.47A1.71,1.71,0,0,0,329.09,177.39Zm7.84.24a.45.45,0,0,0-.58-.53,2,2,0,0,0-1.07,1.31,2.17,2.17,0,0,0,.45,2.26c.09.08.23.15.33.08s0-1,.05-1.27a2.32,2.32,0,0,1,.3-1A3.55,3.55,0,0,0,336.93,177.63Zm-4.28-1.8a.14.14,0,0,0-.21.08.61.61,0,0,0,.12.55,4.35,4.35,0,0,1,.25.63,4.8,4.8,0,0,1,.23,1.31,6.51,6.51,0,0,1-.07,1.25c-.06.39-.17.77-.23,1.16,0,0,0,.15.08.1a2.92,2.92,0,0,0,.82-2.38,5,5,0,0,0-.23-1.42A2.44,2.44,0,0,0,332.65,175.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.72,181l4.61-1.83a2.61,2.61,0,0,1-1.44,3.31A2.42,2.42,0,0,1,321.72,181Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.64,179.15l4.51,2.17a2.4,2.4,0,0,1-3.26,1.23A2.64,2.64,0,0,1,339.64,179.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.34,182.83l.51,12.18,6.91-1C338.67,190.39,335.09,184.59,332.34,182.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,198.66a2.54,2.54,0,0,0-.84.72c-.67.94.14,1.5,1,1.66a7.93,7.93,0,0,1,2.79,1.05,2.34,2.34,0,0,0,1.29.53,1.21,1.21,0,0,0,.79-.4,1.32,1.32,0,0,0,.2-.83,3.37,3.37,0,0,0-1.88-2.8A3.79,3.79,0,0,0,327.35,198.66Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33,202.09a6.88,6.88,0,0,0,.63.37,4.3,4.3,0,0,0-3.87-3.62,2.29,2.29,0,0,0-.58.54c-.67.94.14,1.5,1,1.66A7.93,7.93,0,0,1,330.33,202.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.22,187.6a2.15,2.15,0,1,1-2.14-2.14A2.14,2.14,0,0,1,328.22,187.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.49,187.29a2.15,2.15,0,1,1-2.15-2.14A2.14,2.14,0,0,1,343.49,187.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.93,240.69c-2.57-3.44-2.78-13.21-4.74-15S304.7,215.53,304,210.12l1.64-3.77c-1.39-.78-3.71,3.7-9.61,8.18,0,0-1.13,5.56,2.57,12.29,4.37,7.94,8.52,10.82,8.52,10.82s6.69-7.35,7.71-7.57S319.64,239.27,322.93,240.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.93,240.69c1.72-2.51,2.34-13.41,2.89-14.81,1.14-2.95,4.42-10.56,4.42-10.56a7.31,7.31,0,0,1,1.1,1.27c4.5,6.89,3.6,16.24,2,19-1.2-3.19-4.33-7.43-5-6.68S325.62,239.61,322.93,240.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.59,277.19c11.16-6.59,27.12-15.9,27.12-15.9s25.93-9.34,31.66-13.75c7.37-5.69,14.39-16.24,7.75-27.58-7.38-3-11.42,1.16-28.21,10.18-15.73,8.47-19.68,9.9-26.4,15.76s-19.83,19.62-23.42,21.69c-3.3,1.91-7.71.93-10.85.83s-5.74,1.45-8.29.75-4-4.76-6-6.56-3.49-2.22-4.49-1.5,3.14,7.6,3.14,7.6-5.07-5.34-6.87-6.41-3.91-.23-3.87.76,8.45,9.52,9.61,10.88,4.05,2.54,8.14,3.72,11.16,3.19,15.54,3.42S205.49,281.39,212.59,277.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.64,268.71c1.25,2.07,2.35,4.15,4,5s3.54,1.75,3.54,1.75a29.29,29.29,0,0,1-5.12-1.94C176,272.76,174.64,268.71,174.64,268.71Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.94,261.68l35.13-13.55c6.21-5,11.41-20.55,4.9-31.37-10.58,0-12.68,3-25.86,10.26-9.05,5-19.76,10.63-19.76,10.63-5.59,2.67-12.51,9.58-17.3,14.24s-9.58,9.79-9.58,9.79-1.19,3.65,2.8,8a12.89,12.89,0,0,0,8.78,4.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bolts--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bolts--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "81.85 74.57 75.22 93.2 39.76 59.52 81.25 126 87.94 106.3 119.04 142.74 81.85 74.57",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.94 265.12 84.25 278.34 46.03 283.88 107.19 289.11 99.14 276.24 136.4 275.38 75.94 265.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.89 38.66 373.99 51.56 396.02 22.59 373.67 75.39 366.35 63.18 347.71 93.17 366.89 38.66",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.11 233.22 406.63 249.56 447.46 244.18 386.34 266.71 389.19 253.86 349.03 262.2 410.11 233.22",
    style: {
      fill: "#f0f0f0"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardvaloresresiliencia);
export default __webpack_public_path__ + "static/media/card.valores.resiliencia.b7a55344b0f707e002668986d02153ce.svg";
export { ForwardRef as ReactComponent };